const HowToPlay = () => {

    // Wait for the DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function () {
        const howToPlayIcon = document.querySelector('.header__icon--how');
        const howToPlay = document.getElementById('howToPlay');
        const closeHowToPlayBtn = document.getElementById('closeHowToPlayBtn');
        const overlay = document.getElementById('overlay');

        // Function to open the popup
        function openHowToPlay() {
            howToPlay.classList.add('active');
            overlay.classList.add('active');
        }

        // Function to close the popup
        function closeHowToPlay() {
            howToPlay.classList.remove('active');
            overlay.classList.remove('active');
        }

        // Event listener to open when icon is clicked
        howToPlayIcon.addEventListener('click', openHowToPlay);

        // Event listener to close when close button is clicked
        closeHowToPlayBtn.addEventListener('click', closeHowToPlay);

        // Close when pressing the Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && howToPlay.classList.contains('active')) {
                closeHowToPlay();
            }
        });
    });
}

export default HowToPlay;
